<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Users</h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<!-- /.content-header -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">

        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Add New User</h3>

            </div>
            <div class="card-body">

                <form [formGroup]="addUserForm" (ngSubmit)="onaddUserSubmit()" style="margin-left:250px">
                    <!-- <h5 *ngIf="success">Your form is valid!</h5> -->
                    <!-- <div class="form-group">
                            <label style="font-weight:bold">
                                User Id :
                                <input type="text" formControlName="userId" class="form-control" (blur)='checkExistUserId($event)'>
                             
                            </label>
                        </div> -->
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Name :<span style="color:red;">*</span>
                            <input type="text" style="width:650px" formControlName="userName" class="form-control">

                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Email Id. :<span style="color:red;">*</span>
                            <input type="email" style="width:650px" formControlName="emailId" class="form-control"
                                (blur)='checkExistEmailId($event)'>
                            <div *ngIf="submitted && addUserForm.controls.emailId.errors" class="error">
                                <div *ngIf="addUserForm.controls.emailId.errors.required" style="color:red">Email Id is
                                    required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Mobile No. :<span style="color:red;">*</span>
                            <input type="text" style="width:650px" formControlName="mobileNo" class="form-control"
                                (blur)='checkExistMobileNo($event)' maxlength="10">
                            <div *ngIf="submitted && addUserForm.controls.mobileNo.errors && addUserForm.controls.mobileNo.invalid"
                                class="error">
                                <div *ngIf="addUserForm.controls.mobileNo.errors.required" style="color:red">Mobile No.
                                    is required</div>
                                <div *ngIf="addUserForm.controls.mobileNo.errors.pattern">Please, Enter 10 digit Mobile
                                    Number.</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>
                            Role:<span style="color:red;">*</span>
                            <select [(ngModel)]="selectedRole" style="width:650px" class="form-control"
                                aria-label="Default select example" formControlName="roles" (change)="changeRole($event)">
                                <option selected>Select Role</option>
                                <option value="ROLE_SO">Nodal Officer</option>
                                <option value="ROLE_RO">Regional Officer</option>

                            </select>
                            <div *ngIf="submitted && addUserForm.controls.roles.errors" class="error">
                                <div *ngIf="addUserForm.controls.roles.errors.required"
                                    style="color:red">Role
                                    is required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group" *ngIf="showState">
                        <label>
                            State:<span style="color:red;">*</span>
                            <select [(ngModel)]="selectedState" style="width:650px" formControlName="stateCode"
                                class="form-control">
                                <option [ngValue]="null" selected disabled>Select State</option>
                                <option *ngFor="let state of StateRecord" [ngValue]="state.stateCode">
                                    {{state.stateName}}</option>
                            </select>
                            <div *ngIf="submitted && addUserForm.controls.statecode.errors" class="error">
                                <div *ngIf="addUserForm.controls.statecode.errors.required" style="color:red">State is
                                    required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group" *ngIf="showRegion">
                        <label>
                            Region:
                            <select [(ngModel)]="selectedRegion" style="width:650px" formControlName="regionCode"
                                class="form-control">
                                <option [ngValue]="null" selected disabled>Select Region</option>
                                <option *ngFor="let region of RegionRecord" [ngValue]="region.regionCode">
                                    {{region.regionName}}</option>
                            </select>
                            <div *ngIf="submitted && addUserForm.controls.regionCode.errors" class="error">
                                <div *ngIf="addUserForm.controls.regionCode.errors.required" style="color:red">Region is
                                    required</div>
                            </div>
                        </label>
                    </div>
                    <div class="form-group"></div>
                    <div class="form-group">
                        <label style="font-weight:bold">
                            Designation :<span style="color:red;">*</span>
                            <input type="text" style="width:650px" formControlName="designation" class="form-control">
                            <div *ngIf="submitted && addUserForm.controls.designation.errors "
                                class="error">
                                <div *ngIf="addUserForm.controls.designation.errors.required" style="color:red">Designation
                                    is required</div>
                                
                            </div>

                        </label>
                    </div>



                    <br />

                    <div class="form-group"><input type="submit" value="Submit" class="btn btn-primary"
                            [disabled]="!addUserForm.valid"></div>
    
                </form>
            </div>
        </div>

    </div>
</section>